import React from 'react';
import { API_URLS } from '../../config/Constants';
import KPISettings from '../../components/kpi/KPISettings';

const KPIsPage: React.FC = () => {
  return (
    <div className="w-full max-w-7xl">
      <KPISettings scope="game" fetchUrl={API_URLS.GET_GAME_KPI_TARGETS} updateUrl={API_URLS.UPDATE_GAME_KPI_TARGETS} />
    </div>
  );
};

export default KPIsPage;
